import CommonTable from "@/components/commonTable";
import { calibrateAxBsdCameraRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo } from "react";
import { renderAnXingCalibrationStatus } from "./status";

interface CalibrateTableAxBsdCameraProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableAxBsdCamera = (props: CalibrateTableAxBsdCameraProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {
        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }
        return _params;
    }, [diagnosisSearchParams, carId]);

    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateAxBsdCameraRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

    const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime',
            width: 180
        },
        {
            title: '参数版本号',
            dataIndex: 'version',
            width: 100
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            width: 140,
            render: renderAnXingCalibrationStatus
        },
        {
            title: '标定后位置x',
            dataIndex: 'locationX',
            width: 120
        },
        {
            title: '标定后位置y',
            dataIndex: 'locationY',
            width: 120
        },
        {
            title: '标定后位置z',
            dataIndex: 'locationZ',
            width: 120
        },
        {
            title: '标定后pitch',
            dataIndex: 'pitch',
            width: 120
        },
        {
            title: '标定后yaw',
            dataIndex: 'yaw',
            width: 120
        },
        {
            title: '标定后roll',
            dataIndex: 'roll',
            width: 120
        },
        {
            title: '图像宽（imgW）',
            dataIndex: 'imgW',
            width: 120
        },
        {
            title: '图像高（imgH）',
            dataIndex: 'imgH',
            width: 120
        },
        {
            title: '参考主点x（px）',
            dataIndex: 'px',
            width: 140
        },
        {
            title: '参考主点y（py）',
            dataIndex: 'py',
            width: 140
        },
        {
            title: '焦距x（fx）',
            dataIndex: 'fx',
            width: 120
        },
        {
            title: '焦距y（fy）',
            dataIndex: 'fy',
            width: 120
        },
        {
            title: '实际主点x(cx)',
            dataIndex: 'cx',
            width: 140
        },
        {
            title: '实际主点y(cy)',
            dataIndex: 'cy',
            width: 140
        },
        {
            title: 'KB畸变k1（K1）',
            dataIndex: 'k1',
            width: 140
        },
        {
            title: 'KB畸变k2（K2）',
            dataIndex: 'k2',
            width: 140
        },
        {
            title: 'KB畸变k3（K3）',
            dataIndex: 'k3',
            width: 140
        },
        {
            title: 'KB畸变k4（K4）',
            dataIndex: 'k4',
            width: 140
        },
        {
            title: '安装模式(MountMode)',
            dataIndex: 'mountMode',
            width: 160
        },
        {
            title: '标定模式(CalibrationMode)',
            dataIndex: 'calibrationMode',
            width: 160
        },
        {
            title: '标定场版本(CalibrationFieldVersion)',
            dataIndex: 'calibrationFieldVersion',
            width: 220
        },
        {
            title: '相机模型(CameraModel)',
            dataIndex: 'cameraModel',
            width: 180
        },
        {
            title: '控制点识别模式(DetectionMode)',
            dataIndex: 'detectionMode',
            width: 200
        },
        {
            title: '车辆坐标系原点定义(VehicleCoordOrigin)',
            dataIndex: 'vehicleCoordOrigin',
            width: 240
        },
        {
            title: '标定算法版本号',
            dataIndex: 'algorithmVersion',
            width: 140
        },
        {
            title: '标定上位机版本号',
            dataIndex: 'pcVersion',
            width: 160
        },
        {
            title: '操作时间',
            dataIndex: 'time',
            width: 180
        },
    ];

    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: 4340, y: 400 }}
        />
    );
};

export default CalibrateTableAxBsdCamera;
